import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  joinWaitlistText: {
    marginTop: 'auto',
  },
}));

export default useStyles;
